import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ATag from '../ATag';

const AddNotesIcon = props => {
  const { onClick, ...rest } = props;
  return (
    <ATag onClick={onClick} {...rest}>
      <FontAwesomeIcon
        icon={['fas', 'notes-medical']}
        className={`icon-notesmedical ${props.className}`}
      />
    </ATag>
  );
};

export default AddNotesIcon;
